import Typography from '@mui/material/Typography';
import { DEFAULT_APT_LENGTH } from '../../utils/form/appointmentForm';
import Calendar from '../Scheduler/Calendar';
import useCalendarFormFields from '../../hooks/appointments/useCalendarFormFields';
import { TakenSessionSlot } from '../../types/appointments';
import { cx } from '../../helpers/global';
import theme from '../../constants/theme';

interface CalendarInputProps {
  appointmentLengthInMinutes: string | undefined;
  startDateTime: string;
  onChange: (value: Date) => void;
  onDelete: (() => void) | undefined;
  rescheduleAppointmentId?: string;
  error?: string;
  name?: string;
  takenSlots?: TakenSessionSlot[];
  disabled?: boolean;
  showRequired?: boolean;
}

export const getCalendarInputName = (index: number) =>
  `additionalAppointments.${index}.startDateTime`;

function CalendarInput({
  appointmentLengthInMinutes,
  startDateTime,
  onChange,
  onDelete,
  rescheduleAppointmentId,
  error,
  name,
  takenSlots,
  disabled = false,
  showRequired = false,
}: CalendarInputProps) {
  const { employeeId, serviceCategory, timezone } = useCalendarFormFields();

  return (
    <div className="calendar-input">
      <Calendar
        name={name}
        employeeId={employeeId}
        error={error}
        appointmentLengthInMinutes={
          appointmentLengthInMinutes || DEFAULT_APT_LENGTH
        }
        startDateTime={startDateTime}
        onChange={onChange}
        key={`${employeeId}-appointment-form`}
        disabled={disabled}
        rescheduleAppointmentId={rescheduleAppointmentId}
        serviceCategory={serviceCategory}
        timezone={timezone}
        onDelete={onDelete}
        takenSlots={takenSlots}
      />
      {showRequired && (
        <Typography
          variant="caption"
          className={cx('date-required', !!onDelete && 'with-adornment')}
          fontWeight={600}
          sx={{ color: theme.palette.primary.main }}>
          Required
        </Typography>
      )}
    </div>
  );
}

export default CalendarInput;
